// Copied verbatim from eval/dashboard/internal_web/src/components/ui/ErrorState.tsx (ATM-57). Keep in step until ATM-60 shares it.
import { AlertTriangle, RotateCw } from "lucide-react";

import { ApiError } from "../../api/client";
import { cn } from "../../lib/cn";
import Button from "./Button";

type Props = {
  error: unknown;
  onRetry?: () => void;
  className?: string;
};

/**
 * A failed request, shown with the API's own explanation when there is one.
 *
 * The API answers an unknown enum value with a 400 whose detail names the
 * allowed set, so surfacing `detail` turns a hand-edited URL from a dead end
 * into a fixable mistake.
 */
export default function ErrorState({ error, onRetry, className }: Props) {
  const detail = error instanceof ApiError ? error.detail : null;
  const status = error instanceof ApiError ? error.status : null;
  const message = detail ?? (error instanceof Error ? error.message : "Unknown error");

  return (
    <div
      className={cn("grid place-items-center gap-2 px-4 py-10 text-center", className)}
      role="alert"
    >
      <AlertTriangle size={22} className="text-[color:var(--acuity-4-fg)]" aria-hidden />
      <p className="text-ink">
        Could not load this view{status !== null ? ` (HTTP ${status})` : ""}
      </p>
      <p className="max-w-lg text-body-sm text-ink-2">{message}</p>
      {onRetry !== undefined ? (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-1">
          <RotateCw size={13} aria-hidden />
          Try again
        </Button>
      ) : null}
    </div>
  );
}
